<template lang="pug">
  .make-an-entry-tip.is-flex(v-if="tipsRetrieved")
    .tip-icon
      WtSvgIcon.m-1(icon="icon_tips" width="54px" height="54px")
    .tip-content
      .tip-description.is-family-primary.has-text-weight-light(
        v-html="tips[tipsIndex]['tipLong']"
      )
      WtButton.next-tip-button(@click.native="nextTip") Next Tip
      a.tip-source.is-family-primary(
        :href="tips[tipsIndex]['sourceLink']"
        target="_blank" rel="noopener noreferrer"
      ) {{ tips[tipsIndex]['source'] }}

</template>

<script>
import { mapActions } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtButton from "@@/WtButton/WtButton";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "MakeAnEntryTip",

  components: { WtButton, WtSvgIcon },

  mixins: [dateUtilityMixin],

  props: {
    tipCategory: {
      type: String,
      default: null,
      required: true
    }
  },

  data() {
    return {
      tips: [],
      tipsIndex: 0,
      tipsRetrieved: 0
    };
  },

  async mounted() {
    let response = await this.fetchWellnessTips(this.tipCategory);
    if (response && response.data && response.data.length) {
      this.tips = response.data;
      this.tipsRetrieved = 1;
    }
  },

  methods: {
    ...mapActions("program", ["fetchWellnessTips"]),

    nextTip() {
      if (this.tipsIndex < this.tips.length - 1) {
        this.tipsIndex++;
      } else {
        this.tipsIndex = 0;
      }
    }
  }
};
</script>

<style lang="sass">
.make-an-entry-tip
  max-width: 100%
  background-color: $white-ter
  margin: 50px 0
  border-radius: 20px
  padding: .5rem
  position: relative
  .tip-content
    width: calc(100% - 64px)
    padding-right: 4.5rem
    p
      overflow-wrap: break-word
  .tip-title
    font-size: $size-6
  .next-tip-button
    color: $grey !important
    text-decoration: underline
    background-color: transparent
    margin-bottom: 10px
    position: absolute
    top: 0
    right: 0
    font-size: $size-6
  .next-tip-button:hover
    color: $grey
    text-decoration: underline
    background-color: transparent
  .tip-description
    // overrides db html
    font-size: $size-6 !important
    font-family: $family-primary !important
    *
      font-family: $family-primary !important
      font-size: $size-6 !important
    ul
      list-style: disc
      padding-left: 1.5rem !important
  .tip-source
    color: $navy-dark
    text-decoration-color: $navy-dark
    text-decoration: underline
    font-size: $size-6
</style>
